export const mockProducts = {
  clothing: [
    {
      id: 1,
      name: "Leather Sweatpants",
      category: "Luxury Streetwear",
      price: 495,
      image: "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=800",
      description: "Signature piece worn by Nicki Minaj. Premium leather construction."
    },
    {
      id: 2,
      name: "Elevated Hoodie",
      category: "Essentials",
      price: 285,
      image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800",
      description: "Luxury comfort for people with somewhere to be."
    },
    {
      id: 3,
      name: "Designer Joggers",
      category: "Athletic Luxury",
      price: 325,
      image: "https://images.unsplash.com/photo-1552902865-b72c031ac5ea?w=800",
      description: "Seamless blend of on-court and off-court aesthetics."
    },
    {
      id: 4,
      name: "Premium Jacket",
      category: "Outerwear",
      price: 595,
      image: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800",
      description: "Crafted with meticulous attention to detail."
    }
  ],
  sports: [
    {
      id: 5,
      name: "Custom Team Uniforms",
      category: "Sports Apparel",
      price: 125,
      image: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800",
      description: "Professional-grade uniforms for competitive teams."
    },
    {
      id: 6,
      name: "Basketball Shorts",
      category: "Performance Wear",
      price: 85,
      image: "https://images.unsplash.com/photo-1515523110800-9415d13b84a8?w=800",
      description: "High-performance athletic wear designed for the court."
    },
    {
      id: 7,
      name: "Training Gear Set",
      category: "Athletic Equipment",
      price: 199,
      image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800",
      description: "Complete training solution for serious athletes."
    },
    {
      id: 8,
      name: "Performance Jersey",
      category: "Team Apparel",
      price: 95,
      image: "https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=800",
      description: "Moisture-wicking technology meets premium design."
    }
  ]
};

export const brandHistory = {
  title: "The Story of Perseverance",
  tagline: "Elevated Lifestyle Since 2012",
  highlights: [
    {
      year: "2008",
      title: "The Beginning",
      description: "SoleSearch mobile app launched - first sneaker boutique locator"
    },
    {
      year: "2012",
      title: "PRSVR Founded",
      description: "Brandon & Margaret Williamson establish family-owned elevated lifestyle brand"
    },
    {
      year: "2015",
      title: "Celebrity Recognition",
      description: "Featured on Empire TV show, worn by Nicki Minaj and countless celebrities"
    },
    {
      year: "2018",
      title: "Corporate Partnerships",
      description: "Collaborations with McDonald's, The Recording Academy, and The Hollywood Reporter"
    },
    {
      year: "2020",
      title: "NYFW Debut",
      description: "Showcased at New York Fashion Week, solidifying luxury house status"
    },
    {
      year: "2024",
      title: "Multi-Vertical Expansion",
      description: "Sports, manufacturing, music, and consulting divisions thriving"
    }
  ],
  mission: "The genius thing we did, was we persevered, hence the namesake. PRSVR creates elevated lifestyle pieces that transcend boundaries - designed for people with somewhere to be."
};

export const verticals = [
  {
    id: "clothing",
    name: "PRSVR Fashion",
    tagline: "Elevated Lifestyle Design",
    description: "Luxury pieces that blend on-court aesthetics with off-court sophistication. Meticulous craftsmanship meets timeless style.",
    features: ["Premium Materials", "Celebrity Endorsed", "NYFW Featured", "Limited Editions"]
  },
  {
    id: "sports",
    name: "PRSVR Sports",
    tagline: "Performance Meets Luxury",
    description: "Professional-grade sports uniforms and basketball products. Custom team solutions with premium quality.",
    features: ["Custom Uniforms", "Team Solutions", "Performance Gear", "Basketball Products"]
  },
  {
    id: "manufacturing",
    name: "Manufacturing & Consulting",
    tagline: "Your Brand, Our Expertise",
    description: "End-to-end manufacturing solutions and fashion industry consulting. We design, manufacture, and distribute excellence.",
    features: ["Private Label", "Full Manufacturing", "Industry Consulting", "Quality Control"]
  },
  {
    id: "music",
    name: "Music & Media",
    tagline: "Creative Expression",
    description: "YouTube content creation and music production. Expanding the PRSVR universe through multimedia storytelling.",
    features: ["YouTube Channel", "Music Production", "Creative Content", "Brand Stories"]
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "PRSVR represents the perfect fusion of luxury and street culture. Their pieces are investment-worthy.",
    author: "Fashion Industry Insider",
    role: "Stylist"
  },
  {
    id: 2,
    quote: "The quality and attention to detail in their uniforms is unmatched. Our team looks and performs better.",
    author: "Athletic Director",
    role: "College Sports"
  },
  {
    id: 3,
    quote: "Working with PRSVR on our manufacturing needs was seamless. True professionals who deliver on promises.",
    author: "Brand Owner",
    role: "Emerging Designer"
  }
];